module.exports = __webpack_public_path__ + "static/cut-5f6f7574cf2b6af492aeb363d19dbda8.png";